import React from 'react';
import styled from '@emotion/styled';
import Button from '@via-profit/ui-kit/Button';

import { RouteIcon, SearchIcon } from '../../../assets/icons';

export type Mode = 'search' | 'route';

export interface ToolbarProps {
  readonly mode: Mode;
  readonly onModeChange: (mode: Mode) => void;
}

const Tabs = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.backgroundSecondary.toString()};

  & > * {
    flex: 1;
  }
`;

/** Вкладки "Поиск"/"Маршрут" вверху карточки. */
const Toolbar: React.FC<ToolbarProps> = ({ mode, onModeChange }) => {
  const tab = (value: Mode, label: string, icon: JSX.Element) => (
    <Button
      type="button"
      variant={mode === value ? 'standard' : 'plain'}
      color={mode === value ? 'primary' : 'default'}
      startIcon={icon}
      onClick={() => mode !== value && onModeChange(value)}
    >
      {label}
    </Button>
  );
  return (
    <Tabs>
      {tab('search', 'Поиск', <SearchIcon />)}
      {tab('route', 'Маршрут', <RouteIcon />)}
    </Tabs>
  );
};

export default Toolbar;
